import { InputContainer } from "@/components/ui/forms/inputContainer"
import { Text } from "@/components/ui/baseUi/text"
import { type BoxFormPageProps } from "@modules/box/components/boxCreationForm/boxFormFirstPage"
import { BoxFormTemplatePage } from "@modules/box/components/boxCreationForm/boxFormTemplatePage"
import { word } from "@modules/core/utils/i18n"
import { HUImageForm } from "@modules/ui/components/huImageForm"

export const BoxFormFourthPage = ({
  handleSubmit,
  onPrevious,
  formik,
  getFormErrorMessage,
  disabled,
}: BoxFormPageProps) => {
  const acceptedTypes = "image/jpeg, image/png, image/webp"

  return (
    <BoxFormTemplatePage
      onPrevious={onPrevious}
      handleSubmit={handleSubmit}
      disabled={disabled}
      pageNumber={4}
      header={{
        title: word("box.creation.page.4.title"),
        description: word("box.creation.page.4.description"),
      }}
    >
      <div className="flex flex-col items-center gap-8 md:flex-row">
        <div className="flex flex-col items-center" style={{ maxWidth: "13.75rem" }}>
          <InputContainer error={getFormErrorMessage("logo")} label={word("box.form.logo.label")} isRequiredInput>
            <HUImageForm
              type="logo"
              setImage={(e) => {
                formik.setFieldValue("logo", e)
              }}
              image={formik.values.logo}
              size="220px"
              acceptedTypes={acceptedTypes}
              resizer={true}
              hideButton={true}
              placeHolder={{
                message: word("program.form.uploadImage.text1"),
                style: { paddingLeft: "2.28rem", paddingRight: "2.28rem" },
              }}
            />
          </InputContainer>

          <Text fontStyle="BS" className="text-center text-textDefault-caption">
            {word("box.form.uploadImage.logo.restrictions")}
          </Text>
        </div>

        <div className="flex flex-col items-center" style={{ maxWidth: "13.75rem" }}>
          <InputContainer error={getFormErrorMessage("cover")} label={word("box.form.cover.label")} isRequiredInput>
            <HUImageForm
              type="cover"
              setImage={(e) => {
                formik.setFieldValue("cover", e)
              }}
              image={formik.values.cover}
              size="220px"
              acceptedTypes={acceptedTypes}
              resizer={true}
              hideButton={true}
              placeHolder={{
                message: word("program.form.uploadImage.text1"),
                style: { paddingLeft: "1.75rem", paddingRight: "1.75rem" },
              }}
            />
          </InputContainer>

          <Text fontStyle="BS" className="text-center text-textDefault-caption">
            {word("box.form.uploadImage.cover.restrictions")}
          </Text>
        </div>
      </div>
    </BoxFormTemplatePage>
  )
}
